export default __webpack_public_path__ + "images/43a4a80046ba09251b1a157fbf5c19ca-modal-close.svg";